<template>
  <div class="shop-list-container">
    <!-- 搜索筛选区域 - 响应式布局 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="false" :model="searchForm" class="filter-form" label-width="70px">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="商家名称">
              <el-input v-model="searchForm.sh_name" placeholder="请输入商家名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="商户号">
              <el-input v-model="searchForm.id" placeholder="请输入商户号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="手机号">
              <el-input v-model="searchForm.comlist2" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="审核状态">
              <el-select v-model="searchForm.audit_status" placeholder="全部" clearable>
                <el-option label="待审核" value="审核中"></el-option>
                <el-option label="已通过" value="审核通过"></el-option>
                <el-option label="审核未过" value="审核未过"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24">
            <el-form-item>
              <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
              <el-button @click="resetSearch" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 数据表格 - 优化横向滚动 -->
    <el-card class="table-card" shadow="never">
      <div slot="header" class="table-header">
        <span>店铺列表</span>
        <span class="total-info">共 {{ total }} 条记录</span>
      </div>
      <div class="table-scroll-wrapper">
        <el-table
          v-loading="loading"
          :data="tableData"
          height="56vh"
          border
          stripe
          style="width: 100%"
          :default-sort="{prop: 'id', order: 'descending'}"
          class="scrollable-table"
          :cell-style="cellStyle"
        >
          <el-table-column prop="sh_name" label="商家名称" min-width="140" show-overflow-tooltip></el-table-column>

          <el-table-column prop="sh_img" label="logo" width="70" align="center">
            <template slot-scope="scope">
              <el-avatar
                :src="scope.row.sh_img || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"
                :size="36"
                @error="handleAvatarError"
              >
                <i class="el-icon-picture-outline"></i>
              </el-avatar>
            </template>
          </el-table-column>

          <el-table-column prop="display_merchant_no" label="商户号" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.display_merchant_no || scope.row.id || '--' }}
            </template>
          </el-table-column>

          <el-table-column prop="comlist_v2_2" label="省市" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.comlist_v2_2 || '--' }}
            </template>
          </el-table-column>

          <el-table-column prop="comlist2" label="手机号" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.comlist2 || '--' }}
            </template>
          </el-table-column>

          <el-table-column prop="comlist_v5" label="经营范围" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.comlist_v5 || '--' }}
            </template>
          </el-table-column>

          <el-table-column prop="sh_rank" label="商户等级" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="rankType(scope.row.sh_rank)" effect="plain" size="small">
                {{ rankName(scope.row.sh_rank) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="audit_status" label="审核状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag :type="auditStatusType(scope.row.audit_status)" effect="dark" size="small">
                {{ auditStatusName(scope.row.audit_status) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="promotion_code" label="推广码" min-width="130" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="promotion-code">
                <span>{{ scope.row.promotion_code || '暂无' }}</span>
                <i
                  v-if="scope.row.promotion_code"
                  class="el-icon-document-copy copy-icon"
                  @click="copyToClipboard(scope.row.promotion_code)"
                  title="复制推广码"
                ></i>
              </div>
            </template>
          </el-table-column>

          <!-- 操作列：编辑 + 推广码 -->
          <el-table-column label="操作" min-width="150" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="openEditDialog(scope.row)"
                class="edit-btn"
              >
                编辑
              </el-button>
              <el-button
                type="success"
                size="mini"
                icon="el-icon-star-off"
                @click="openPromotionDialog(scope.row)"
                class="promotion-btn"
              >
                推广码
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页组件 - 响应式布局 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :small="isSmallScreen"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 编辑商家信息弹窗 (保持不变) -->
    <el-dialog
      title="编辑商家信息"
      :visible.sync="editDialogVisible"
      width="90%"
      :style="{ maxWidth: '700px', marginTop: '-5vh', marginLeft: '36%' }"
      :close-on-click-modal="false"
      @close="closeEditDialog"
    >
      <div v-if="currentEditShop" class="edit-content">
        <h3 class="shop-title">{{ currentEditShop.sh_name }} (ID: {{ currentEditShop.id }})</h3>
        <el-divider></el-divider>
        <el-form :model="editForm" label-width="100px" size="small" ref="editFormRef" :rules="editRules" label-position="right">
          <el-form-item label="商家名称" prop="sh_name">
            <el-input v-model="editForm.sh_name" placeholder="请输入商家名称" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="Logo">
            <img v-if="editForm.sh_img_url" :src="editForm.sh_img_url" class="avatar" style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px;">
          </el-form-item>

          <el-form-item label="商户等级" prop="sh_rank">
            <el-select v-model="editForm.sh_rank" placeholder="请选择商户等级" :disabled="true">
              <el-option label="普通商户" :value="1"></el-option>
              <el-option label="高级商户" :value="2"></el-option>
              <el-option label="金牌商户" :value="3"></el-option>
              <el-option label="旗舰商户" :value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所在市场" prop="comlist_v2">
            <el-input v-model="editForm.comlist_v2" placeholder="请输入市场名称" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="省市" prop="comlist_v2_2">
            <el-input v-model="editForm.comlist_v2_2" placeholder="请输入省市" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="经营范围" prop="comlist_v5">
            <el-input v-model="editForm.comlist_v5" placeholder="例如：副食饮料,肉禽蛋奶" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="商家类型" prop="comlist_v6">
            <el-input v-model="editForm.comlist_v6" placeholder="例如：市场批发商" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="手机号" prop="comlist2">
            <el-input v-model="editForm.comlist2" placeholder="联系电话" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="审核状态" prop="sh_type">
            <el-select v-model="editForm.sh_type" placeholder="审核状态">
              <el-option label="审核中" value="审核中"></el-option>
              <el-option label="审核通过" value="审核通过"></el-option>
              <el-option label="审核未过" value="已拒绝"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit" :loading="editSubmitting">保 存 更 新</el-button>
      </span>
    </el-dialog>

    <!-- 新增：添加推广码弹窗 -->
    <el-dialog
      title="添加推广码"
      :visible.sync="promotionDialogVisible"
      width="90%"
      :style="{ maxWidth: '500px', marginLeft:'40%'}"
      :close-on-click-modal="false"
      @close="closePromotionDialog"
    >
      <div v-if="currentPromotionShop" class="promotion-content">
        <div class="shop-info">
          <span class="label">商家：</span>
          <span class="value">{{ currentPromotionShop.sh_name }} (ID: {{ currentPromotionShop.id }})</span>
        </div>
        <el-form :model="promotionForm" label-width="80px" size="small" ref="promotionFormRef" :rules="promotionRules">
          <el-form-item label="推广码" prop="Invite_code">
            <el-input v-model="promotionForm.Invite_code" placeholder="请输入推广码（字母/数字组合）" maxlength="20"></el-input>
            <div class="form-tip">* 推广码需唯一，不可与已有重复</div>
          </el-form-item>
          <!-- hr_user 隐藏自动填充，不需要用户输入 -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="promotionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPromotion" :loading="promotionSubmitting">确 定 添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Cookie from 'js-cookie'

const token = Cookie.get('token')
const dlRequest = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})
const editRequest = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})
// 推广码专用请求（JSON格式）
const promoRequest = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})

export default {
  name: 'ShopListManage',
  data () {
    return {
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      limit: 20,
      searchForm: {
        sh_name: '',
        id: '',
        comlist2: '',
        audit_status: ''
      },
      editDialogVisible: false,
      currentEditShop: null,
      editForm: {
        sh_name: '',
        sh_img_file: null,
        sh_img_url: '',
        sh_rank: 1,
        comlist_v2: '',
        comlist_v2_2: '',
        comlist_v5: '',
        comlist_v6: '',
        comlist2: '',
        sh_type: ''
      },
      editSubmitting: false,
      editRules: {
        sh_name: [
          { required: true, message: '请输入商家名称', trigger: 'blur' },
          { max: 100, message: '长度不超过100个字符', trigger: 'blur' }
        ],
        sh_rank: [
          { required: true, message: '请选择商户等级', trigger: 'change' }
        ]
      },
      tableHeight: 'auto',
      isSmallScreen: false,

      // 推广码弹窗相关
      promotionDialogVisible: false,
      currentPromotionShop: null,
      promotionForm: {
        Invite_code: ''
        // hr_user 将从 cookie 自动获取，不在 UI 显示
      },
      promotionSubmitting: false,
      promotionRules: {
        Invite_code: [
          { required: true, message: '请输入推广码', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '推广码只能包含字母和数字', trigger: 'blur' },
          { max: 20, message: '长度不能超过20个字符', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.fetchShopList()
    this.calculateTableHeight()
    window.addEventListener('resize', this.handleResize)
    this.checkScreenSize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    mapAuditStatus (shType) {
      if (shType === '审核通过') return 1
      if (shType === '待审核') return 0
      if (shType === '审核未过') return 2
      return 0
    },
    async fetchShopList () {
      this.loading = true
      try {
        const params = {
          id: this.searchForm.id || '',
          sh_name: this.searchForm.sh_name || '',
          mem_user: this.searchForm.comlist2 || '',
          sh_type: this.searchForm.audit_status,
          page: this.page,
          limit: this.limit
        }
        if (this.searchForm.audit_status !== '') {
          params.audit_status = this.searchForm.audit_status
        }
        const response = await dlRequest.post('https://api.gd.91comerp.com/index/all_dian_list.php', { ...params })
        if (response.data && response.data.code === 0) {
          let list = response.data.list || []
          list = list.map(item => ({
            ...item,
            audit_status: this.mapAuditStatus(item.sh_type),
            display_merchant_no: item.id,
            promotion_code: item.Invite_code || '',
            tg_count: parseInt(item.nhr_buy) || 0
          }))
          this.tableData = list
          this.total = response.data.total || list.length
        } else {
          this.$message.error(response.data?.msg || '获取列表失败')
        }
      } catch (error) {
        console.error('请求异常:', error)
        this.$message.error('网络请求失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleSearch () {
      this.page = 1
      this.fetchShopList()
    },
    resetSearch () {
      this.searchForm = {
        sh_name: '',
        id: '',
        comlist_2: '',
        audit_status: ''
      }
      this.page = 1
      this.fetchShopList()
    },
    handleSizeChange (val) {
      this.limit = val
      this.page = 1
      this.fetchShopList()
    },
    handleCurrentChange (val) {
      this.page = val
      this.fetchShopList()
    },
    rankName (rank) {
      const map = { 1: '普通商户', 2: '高级商户', 3: '金牌商户', 4: '旗舰商户' }
      return map[rank] || '普通商户'
    },
    rankType (rank) {
      const typeMap = { 1: 'info', 2: 'success', 3: 'warning', 4: 'danger' }
      return typeMap[rank] || 'info'
    },
    auditStatusName (status) {
      const map = { 0: '待审核', 1: '已通过', 2: '审核未过' }
      return map[status] !== undefined ? map[status] : '未知'
    },
    auditStatusType (status) {
      const typeMap = { 0: 'warning', 1: 'success', 2: 'danger' }
      return typeMap[status] || 'info'
    },
    handleAvatarError () {
      return false
    },
    copyToClipboard (code) {
      if (!code) return
      const input = document.createElement('input')
      input.value = code
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('推广码已复制')
    },
    openEditDialog (row) {
      this.currentEditShop = row
      this.editForm = {
        sh_name: row.sh_name || '',
        sh_img_file: null,
        sh_img_url: row.sh_img || '',
        sh_rank: row.sh_rank ? Number(row.sh_rank) : 1,
        comlist_v2: row.comlist_v2 || '',
        comlist_v2_2: row.comlist_v2_2 || '',
        comlist_v5: row.comlist_v5 || '',
        comlist_v6: row.comlist_v6 || '',
        comlist2: row.comlist2 || '',
        sh_type: row.sh_type || '待审核'
      }
      this.editDialogVisible = true
    },
    handleLogoChange (file) {
      const isImage = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png'
      const isLt2M = file.raw.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式图片!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
        return false
      }
      this.editForm.sh_img_file = file.raw
      const reader = new FileReader()
      reader.onload = (e) => {
        this.editForm.sh_img_url = e.target.result
      }
      reader.readAsDataURL(file.raw)
    },
    beforeLogoUpload (file) {
      return false
    },
    submitEdit () {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        this.editSubmitting = true
        try {
          const formData = new FormData()
          formData.append('id', this.currentEditShop.id)
          formData.append('sh_name', this.editForm.sh_name)
          formData.append('sh_rank', this.editForm.sh_rank)
          formData.append('comlist_v2', this.editForm.comlist_v2)
          formData.append('comlist_v2_2', this.editForm.comlist_v2_2)
          formData.append('comlist_v5', this.editForm.comlist_v5)
          formData.append('comlist_v6', this.editForm.comlist_v6)
          formData.append('comlist2', this.editForm.comlist2)
          formData.append('sh_type', this.editForm.sh_type)
          if (this.editForm.sh_img_file) {
            formData.append('sh_img', this.editForm.sh_img_file)
          }

          const response = await editRequest.post('https://api.gd.91comerp.com/index/update_shop_info.php', formData)
          if (response.data && response.data.code === 0) {
            this.$message.success('商家信息更新成功')
            this.editDialogVisible = false
            this.fetchShopList()
          } else {
            this.$message.error(response.data?.msg || '更新失败')
          }
        } catch (error) {
          console.error('编辑商家异常:', error)
          this.$message.error('网络错误，请重试')
        } finally {
          this.editSubmitting = false
        }
      })
    },
    closeEditDialog () {
      this.currentEditShop = null
      this.editForm = {
        sh_name: '',
        sh_img_file: null,
        sh_img_url: '',
        sh_rank: 1,
        comlist_v2: '',
        comlist_v2_2: '',
        comlist_v5: '',
        comlist_v6: '',
        comlist2: '',
        sh_type: ''
      }
      if (this.$refs.editFormRef) this.$refs.editFormRef.resetFields()
    },
    cellStyle () {
      if (this.isSmallScreen) {
        return {
          padding: '6px 0'
        }
      }
      return {}
    },
    calculateTableHeight () {
      this.$nextTick(() => {
        const windowHeight = window.innerHeight
        const otherElementsHeight = 280
        let height = windowHeight - otherElementsHeight
        height = Math.max(height, 300)
        this.tableHeight = height
      })
    },
    handleResize () {
      this.calculateTableHeight()
      this.checkScreenSize()
    },
    checkScreenSize () {
      this.isSmallScreen = window.innerWidth < 768
    },

    // ========== 推广码弹窗相关方法 ==========
    openPromotionDialog (row) {
      this.currentPromotionShop = row
      this.promotionForm.Invite_code = ''
      this.promotionDialogVisible = true
      // 清除校验
      this.$nextTick(() => {
        if (this.$refs.promotionFormRef) {
          this.$refs.promotionFormRef.clearValidate()
        }
      })
    },
    closePromotionDialog () {
      this.currentPromotionShop = null
      this.promotionForm.Invite_code = ''
      if (this.$refs.promotionFormRef) {
        this.$refs.promotionFormRef.resetFields()
      }
    },
    async submitPromotion () {
      // 表单校验
      const valid = await this.$refs.promotionFormRef.validate().catch(() => false)
      if (!valid) return
      const params = {
        id: this.currentPromotionShop.id,
        sh_name: this.currentPromotionShop.sh_name,
        hr_user: Cookie.get('account'),
        Invite_code: this.promotionForm.Invite_code,
        comlist2: Cookie.get('account')
      }

      this.promotionSubmitting = true
      try {
        // 调用推广码接口（根据之前改造的接口地址）
        const response = await promoRequest.post('https://api.gd.91comerp.com/index/code_sh_add.php', params)
        if (response.data && response.data.code === 0) {
          this.$message.success('推广码添加成功')
          this.promotionDialogVisible = false
          // 刷新列表以显示新推广码
          this.fetchShopList()
        } else {
          this.$message.error(response.data?.msg || '添加失败，请检查推广码是否重复')
        }
      } catch (error) {
        console.error('添加推广码异常:', error)
        let errMsg = '网络请求失败'
        if (error.response && error.response.data && error.response.data.msg) {
          errMsg = error.response.data.msg
        }
        this.$message.error(errMsg)
      } finally {
        this.promotionSubmitting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shop-list-container {
  padding: 16px;
  background-color: #f0f2f6;
  height: 85vh;
  overflow: auto;
  box-sizing: border-box;
  @media (max-width: 768px) {
    padding: 12px;
  }

  .filter-card {
    margin-bottom: 16px;
    border-radius: 8px;

    ::v-deep .el-card__body {
      padding: 16px;

      @media (max-width: 768px) {
        padding: 12px;
      }
    }

    .filter-form {
      ::v-deep .el-form-item {
        margin-bottom: 12px;
        width: 100%;

        .el-form-item__label {
          width: 70px;
          font-size: 13px;
        }

        .el-form-item__content {
          flex: 1;
        }
      }
    }
  }

  .table-card {
    border-radius: 8px;

    ::v-deep .el-card__header {
      padding: 12px 16px;

      @media (max-width: 768px) {
        padding: 10px 12px;
      }
    }

    ::v-deep .el-card__body {
      padding: 16px;

      @media (max-width: 768px) {
        padding: 12px;
      }
    }

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
      font-size: 15px;

      .total-info {
        font-size: 12px;
        color: #909399;
        font-weight: normal;
      }
    }

    .table-scroll-wrapper {
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;

      &::-webkit-scrollbar {
        height: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;

        &:hover {
          background: #a8a8a8;
        }
      }

      .scrollable-table {
        width: 100%;

        @media (max-width: 768px) {
          ::v-deep .el-table__header-wrapper,
          ::v-deep .el-table__body-wrapper {
            font-size: 12px;
          }

          ::v-deep .el-table__body td {
            font-size: 12px;
          }

          ::v-deep .el-tag {
            font-size: 10px;
            padding: 0 6px;
            height: 20px;
            line-height: 18px;
          }

          ::v-deep .el-button--mini {
            padding: 5px 8px;
            font-size: 11px;

            .el-icon-edit,
            .el-icon-star-off {
              font-size: 11px;
            }
          }
        }

        ::v-deep .el-table .cell {
          white-space: nowrap;
        }

        ::v-deep .el-table__row {
          height: auto;
        }
      }
    }

    .promotion-code {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 6px;

      .copy-icon {
        cursor: pointer;
        color: #409eff;
        font-size: 14px;
        flex-shrink: 0;

        &:hover {
          color: #66b1ff;
        }
      }
    }
  }

  .pagination-container {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;

    @media (max-width: 768px) {
      justify-content: center;

      ::v-deep .el-pagination {
        .el-pagination__total,
        .el-pagination__sizes,
        .el-pagination__jump {
          display: none;
        }

        .btn-prev,
        .btn-next,
        .el-pager li {
          min-width: 28px;
          height: 28px;
          line-height: 28px;
          font-size: 12px;
        }
      }
    }
  }

  .edit-content {
    .shop-title {
      font-size: 16px;
      color: #303133;
      margin-bottom: 8px;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }

    .avatar {
      display: block;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      object-fit: cover;
    }

    ::v-deep .el-form-item {
      margin-bottom: 16px;

      .el-form-item__label {
        font-size: 13px;

        @media (max-width: 768px) {
          width: 80px !important;
          font-size: 12px;
        }
      }
    }
  }

  // 推广码弹窗样式
  .promotion-content {
    .shop-info {
      margin-bottom: 20px;
      padding: 8px 12px;
      background-color: #f5f7fa;
      border-radius: 4px;
      font-size: 14px;

      .label {
        font-weight: 600;
        color: #606266;
      }
      .value {
        color: #303133;
        margin-left: 8px;
      }
    }
    .form-tip {
      font-size: 12px;
      color: #909399;
      margin-top: 4px;
    }
    ::v-deep .el-form-item {
      margin-bottom: 16px;
    }
  }
}

@media (max-width: 768px) {
  .el-dialog {
    margin: 20px auto !important;

    .el-dialog__header {
      padding: 16px 20px 10px;

      .el-dialog__title {
        font-size: 16px;
      }
    }

    .el-dialog__body {
      padding: 16px 20px;
    }
  }
}
</style>
